/**
 * Серверные часы у клиента.
 *
 * ЗАЧЕМ ЭТО ВООБЩЕ НУЖНО. Таймер на сцене задан МЕТКОЙ: «до 19:30:00
 * по серверу», а не «осталось 300 секунд». Иначе пришлось бы тикать
 * по сети — слать «осталось 299», «298», «297» — и это шестьдесят
 * сообщений в минуту на каждый таймер, каждое из которых может
 * опоздать или потеряться (docs/04).
 *
 * Но у метки есть цена: часы машины стримера могут врать. OBS ставят
 * на игровые машины, где NTP отключён «чтобы не лагало», и разбег
 * в минуту там не редкость. Таймер, считающий по таким часам,
 * покажет зрителям чужое время — и хуже того, покажет РАЗНОЕ время
 * на двух оверлеях одного канала.
 *
 * Отсюда поправка: сервер называет своё время при подключении
 * и в каждом ответе на пинг, а мы держим разницу и считаем по ней.
 *
 * НЕСИНХРОНИЗИРОВАННЫЕ ЧАСЫ НЕ ОСТАНАВЛИВАЮТ ТАЙМЕР. Поправка
 * по умолчанию нулевая, то есть таймер идёт по местным часам:
 * возможно, со сдвигом, но идёт. Замерший до первой синхронизации
 * таймер стример прочитал бы как поломку.
 */
/** Часы, по которым считают таймеры. */
export class Clock {
    local;
    offset = 0;
    known = false;
    constructor(local = () => Date.now()) {
        this.local = local;
    }
    /** Текущее серверное время, мс. */
    now() {
        return this.local() + this.offset;
    }
    /** Поправка к местным часам, мс. */
    get offsetMs() {
        return this.offset;
    }
    /** Называл ли сервер своё время хоть раз. */
    get synced() {
        return this.known;
    }
    /**
     * Учитывает метку сервера.
     *
     * ПОЛОВИНА ВРЕМЕНИ ОБОРОТА — не педантизм: метка сервера доехала
     * до нас за половину оборота (грубо), и без этой поправки часы
     * отставали бы ровно на неё. При обороте в двести миллисекунд
     * это сотня, и на секундном таймере она решает, когда сменится
     * цифра.
     *
     * Оборот необязателен: `welcome` приходит без него, и знать
     * задержку рукопожатия неоткуда. Ноль там честнее выдуманного
     * числа.
     */
    sync(serverMs, roundTripMs = 0) {
        if (!Number.isFinite(serverMs))
            return;
        const trip = Number.isFinite(roundTripMs) && roundTripMs > 0 ? roundTripMs / 2 : 0;
        this.offset = serverMs + trip - this.local();
        this.known = true;
    }
    /** Забывает поправку. Нужно тестам и смене сервера. */
    reset() {
        this.offset = 0;
        this.known = false;
    }
}
/**
 * Часы страницы.
 *
 * Модульные по той же причине, что звуковой граф и кеш прогрева:
 * поправка — свойство СОЕДИНЕНИЯ, а не отдельного слоя, и тащить
 * её в контракт виджета значило бы объяснять часы каждому
 * следующему примитиву.
 *
 * ОДНИ НА СТРАНИЦУ: двое часов с разной поправкой — это два таймера
 * на одной сцене, показывающие разное.
 */
let current = new Clock();
export function setClock(clock) {
    current = clock;
}
export function clock() {
    return current;
}
/** Текущее серверное время. Короткая запись для виджетов. */
export function serverNow() {
    return current.now();
}
//# sourceMappingURL=clock.js.map